/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export function normalizeModelName(model: string) {
  return model.toLowerCase().replace(/[&./]/, '').replace(/\s+/g, '-');
}
